import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	defaultPlaceholder: {
		id: 'portfolio-3-common.dropdown-menu.default-placeholder',
		defaultMessage: 'Select from a list',
		description: 'Default placeholder for dropdown menu',
	},
});
